module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.documentSet) ? _c('div', {
    staticClass: "document-set-header well clearfix"
  }, [_c('h1', [_vm._v(_vm._s(_vm.documentSet.name))]), _vm._v(" "), (_vm.documentSet.owners) ? _c('div', {
    staticClass: "owners"
  }, [_c('span', {
    staticClass: "user-label"
  }, [_vm._v("For")]), _vm._v(" "), _vm._l((_vm.documentSet.owners), function(owner) {
    return _c('div', {
      staticClass: "owner"
    }, [_vm._v(_vm._s(owner.user.firstName) + " " + _vm._s(owner.user.lastName))])
  })], 2) : _vm._e(), _vm._v(" "), (_vm.documentSet.attorneys) ? _c('div', {
    staticClass: "more-info collapse clearfix",
    attrs: {
      "id": "moreInfoBlock"
    }
  }, [_c('div', {
    staticClass: "flexbox"
  }, [_c('div', {
    staticClass: "attorneys well col-xs-12",
    class: _vm.documentSet.staff.length ? 'col-sm-6' : ''
  }, _vm._l((_vm.documentSet.attorneys), function(attorney) {
    return _c('div', {
      staticClass: "attorney clearfix"
    }, [_c('div', {
      staticClass: "headshot-col col-md-3 col-md-offset-0 col-xs-6 col-xs-offset-3"
    }, [_c('img', {
      staticClass: "img-circle img-responsive headshot",
      attrs: {
        "src": attorney.user.pictureFileThumbUrl,
        "alt": ""
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "col-md-9 col-xs-12"
    }, [_c('h2', {
      staticClass: "user-label"
    }, [_vm._v("Attorney"), (_vm.documentSet.attorneys.length != 1) ? _c('span', [_vm._v("s")]) : _vm._e()]), _vm._v(" "), _c('div', {
      staticClass: "info-block"
    }, [_c('h4', [_vm._v(_vm._s(attorney.user.firstName) + " " + _vm._s(attorney.user.lastName))]), _vm._v(" "), _c('p', [_c('a', {
      attrs: {
        "href": 'mailto:' + attorney.user.email
      }
    }, [_vm._v(_vm._s(attorney.user.email))])]), _vm._v(" "), _c('p', [_c('a', {
      attrs: {
        "href": 'tel:' + attorney.user.contacts.phone1
      }
    }, [_vm._v(_vm._s(attorney.user.contacts.phone1))])])])])])
  }), 0), _vm._v(" "), (_vm.documentSet.staff.length) ? _c('div', {
    staticClass: "staff col-sm-6 col-lg-6 col-xs-12 well"
  }, [_c('h2', {
    staticClass: "user-label"
  }, [_vm._v("Paralegals/Assistants")]), _vm._v(" "), _c('ul', {
    staticClass: "staff-list"
  }, _vm._l((_vm.documentSet.staff), function(staff) {
    return _c('li', {
      staticClass: "info-block"
    }, [_c('h4', [_vm._v(_vm._s(staff.user.firstName) + _vm._s(staff.user.lastName))]), _vm._v(" "), _c('p', [_c('a', {
      attrs: {
        "href": 'mailto:' + staff.user.email,
        "title": ""
      }
    }, [_vm._v(_vm._s(staff.user.email))])])])
  }), 0)]) : _vm._e()])]) : _vm._e(), _vm._v(" "), (_vm.documentSet.attorneys) ? _c('a', {
    staticClass: "more-btn",
    attrs: {
      "type": "button",
      "data-toggle": "collapse",
      "data-target": "#moreInfoBlock",
      "aria-expanded": "false",
      "aria-controls": "moreInfoBlock"
    }
  }, [_c('i', {
    staticClass: "fa fa-chevron-circle-down"
  })]) : _vm._e()]) : _vm._e()
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-52025e8b"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/DocumentSetHeader.vue
// module id = 280
// module chunks = 1